import { useTableStoreContext } from '@/components/table/contexts/TableContext.tsx';
import React from 'react';
import { quickFiltersDisplay } from '@/components/table/_quickFilters/quickFiltersDisplay.tsx';
import { cn } from '@/lib/utils.ts';
import { QuickFilter } from '@/components/table/types/TableDefinitionDto.ts';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';

const QuickFilters = () => {
  const tableDefinition = useTableStoreContext(
    (state) => state.tableDefinition,
  );
  const selectedQuickFilters = useTableStoreContext(
    (state) => state.quickFilterState,
  );

  const quickFiltersList = tableDefinition.quickFilters || [];

  if (quickFiltersList.length === 0) {
    return null;
  }

  return (
    <>
      {quickFiltersList.map((quickFilterDef) => (
        <QuickFilterItem
          key={quickFilterDef.id}
          quickFilterDef={quickFilterDef}
          isActive={selectedQuickFilters[quickFilterDef.id]}
        />
      ))}
    </>
  );
};

const QuickFilterItem = ({
  quickFilterDef,
  isActive,
}: {
  quickFilterDef: QuickFilter;
  isActive: boolean;
}) => {
  const addQuickFilter = useTableStoreContext((state) => state.addQuickFilter);
  const quickFilterConfig = quickFiltersDisplay[quickFilterDef.id];
  if (!quickFilterConfig) {
    return null;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          key={quickFilterDef.id}
          className={cn(
            'group flex size-[30px] items-center justify-center rounded-md border transition',
            {
              'border-neutral-200 hover:bg-neutral-100': !isActive,
              'border-accent-200 bg-accent-100 hover:bg-accent-200': isActive,
            },
          )}
          onClick={() => addQuickFilter({ [quickFilterDef.id]: !isActive })}
          aria-label={quickFilterConfig.name}
          aria-pressed={isActive}
        >
          <div
            className={cn('group-hover [&>svg]:size-[15px]', {
              '[&>svg]:text-neutral-500': !isActive,
              '[&>svg]:text-accent-700': isActive,
            })}
          >
            {quickFilterConfig.icon}
          </div>
        </button>
      </TooltipTrigger>
      <TooltipContent>
        {isActive ? quickFilterConfig.labelOn : quickFilterConfig.labelOff}
      </TooltipContent>
    </Tooltip>
  );
};

export default QuickFilters;
